import { TSkuItem } from "@elixir/types";
import { PAY_MODES, RECEIPT_DISCOUNT_TYPE } from "../../constants/receipt";
import { TReceiptSku } from "../../types/appointment";
import { LocalServiceEntity } from "../../types/receipt";
import { TStorePaymode } from "./types";

export const defaultService = ({
  receiptSku,
  skuItem,
}: {
  receiptSku?: TReceiptSku;
  skuItem?: TSkuItem;
}): LocalServiceEntity => {
  if (receiptSku) {
    const {
      quantity,
      discount_amount,
      discount_value,
      discount_type,
      sku_item,
    } = receiptSku;

    const discountTypeObject = RECEIPT_DISCOUNT_TYPE.find(
      (dty) => dty.id === discount_type
    );

    return {
      id: sku_item.service_id || 1,
      name: sku_item?.service_name || "",
      cost: {
        curr: "INR",
        price: sku_item?.price || 0,
        discountToShowWithType: discount_amount.toString(),
        qty: quantity,
        discount: discount_value,
        discountType: discountTypeObject
          ? discountTypeObject
          : RECEIPT_DISCOUNT_TYPE[0],
      },
    };
  }

  const { price, service_id, service_name } = skuItem || {};

  return {
    id: service_id || 0,
    name: service_name || "",
    cost: {
      curr: "INR",
      price: price || 0,
      discountToShowWithType: "0",
      qty: 1,
      discount: 0,
      discountType: RECEIPT_DISCOUNT_TYPE[0],
    },
  };
};

export const defaultPayMode = ({
  data,
  total = 0,
  index = 0,
}: {
  data?: TStorePaymode[];
  total?: number;
  index?: number;
}) => {
  if (data?.length === 0) {
    return {
      amount: total,
      paymode: PAY_MODES[index].id,
    };
  }
  const amountTotal =
    ((total - (data?.[data.length - 1]?.amount || 0)) * 100) / 100;
  return {
    amount: amountTotal > 0 ? amountTotal : 0,
    paymode: PAY_MODES[index].id,
  };
};
